module.exports = __webpack_public_path__ + "img/e2c-x1a.prt.02496b87.jpg";